import * as React from 'react';
import { useEffect, useState } from 'react';
import {
  UpdateRequestContextRequest,
  UpdateRequestContextResponse,
  UserRequestContext,
} from 'aws-sdk/clients/awsdatalakegladstonelambda';
import ChatBubble from '@amzn/awsui-chat-components-console/chat-bubble';
import { Container, Header, PromptInput, SpaceBetween, StatusIndicator } from '@amzn/awsui-components-react-v3';
import { Avatar } from '@amzn/awsui-chat-components-console';
import { CopiableText, getPhoneToolUrl } from 'src/commons/common';
import { getUser } from 'src/api/auth';
import { updateRequestContext } from 'src/api/permissions';

export interface RequestContextCommentsProps {
  requestContext: UserRequestContext;
  setRequestContext: any;
  readOnly: boolean;
}

export const RequestContextComments = (props: RequestContextCommentsProps) => {
  const [newComment, setNewComment] = useState<string>('');
  const [user, setUser] = useState<string>(undefined);
  const [errorMessage, setErrorMessage] = useState<string>(undefined);

  useEffect(() => {
    setActiveUser();
  }, []);

  const setActiveUser = async () => {
    setUser(await getUser());
  };

  const handleOnKeyDown = async (keyCode: number) => {
    if (keyCode == 13) {
      // ENTER
      await handleAddComment();
    }
  };

  const handleAddComment = async () => {
    if (!newComment || newComment.length == 0) {
      return;
    }
    try {
      const updateRequestContextRequest: UpdateRequestContextRequest = {
        id: props.requestContext.requestContextId,
        contextScope: props.requestContext.contextScope,
        metadata: {
          d3AValidationContext: props.requestContext.metadata.d3AValidationContext,
          correspondenceMessages: [
            ...props.requestContext.metadata.correspondenceMessages,
            {
              user: user,
              timeStamp: new Date().toISOString(),
              message: newComment,
            },
          ],
        },
      };
      const updateRequestContextResponse: UpdateRequestContextResponse = await updateRequestContext(
        updateRequestContextRequest,
      );
      props.setRequestContext(updateRequestContextResponse.userRequestContext);
      setErrorMessage(undefined);
      setNewComment('');
    } catch (e) {
      console.error(e);
      setErrorMessage('Error when adding comment.');
    }
  };

  return (
    <Container header={<Header variant={'h2'}>Correspondence</Header>}>
      <SpaceBetween size={'l'} direction={'vertical'}>
        {props.requestContext.metadata.correspondenceMessages.map((message) => (
          <ChatBubble
            avatar={<Avatar imgUrl={getPhoneToolUrl(message.user)} ariaLabel={message.user} />}
            type={user == message.user ? 'outgoing' : 'incoming'}
            ariaLabel={'test'}
          >
            <CopiableText copiable={false} name={`${message.user} (${message.timeStamp})`} value={message.message} />
          </ChatBubble>
        ))}
        <PromptInput
          onChange={({ detail }) => setNewComment(detail.value)}
          onKeyDown={(e) => handleOnKeyDown(e.detail.keyCode)}
          value={newComment}
          disabled={props.readOnly}
          actionButtonAriaLabel='Send message'
          actionButtonIconName='send'
          onAction={handleAddComment}
          ariaLabel='Add a comment'
          placeholder='Add a comment'
        />
        {errorMessage && <StatusIndicator type={'error'}>{errorMessage}</StatusIndicator>}
      </SpaceBetween>
    </Container>
  );
};
